$(document).ready(function() {
    console.log('DOM is ready');
    const productId = 8736396411129;
    const variantId = 47072235979001;
    const shippingProtectionToggle = $('#shipping-protection');

    // Function to update cart display
    function updateCartDisplay() {
      const cartNotification = document.querySelector('cart-notification');
      if (cartNotification) {
        cartNotification.renderContents();
      }
    }

    // Function to check if the product is in the cart
    function checkShippingProtectionInCart() {
      $.getJSON('/cart.js', function(cart) {
        const itemInCart = cart.items.some(item => item.product_id === productId && item.variant_id === variantId);
        shippingProtectionToggle.prop('checked', itemInCart);
        //shippingProtectionToggle.prop('disabled', itemInCart); // Allow toggling off
      });
    }

    // Initial check on page load
    checkShippingProtectionInCart();

    shippingProtectionToggle.on('change', function() {
      if ($(this).is(':checked')) {
        // Add shipping protection to cart
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            items: [{
              id: variantId,
              quantity: 1
            }]
          },
          dataType: 'json',
          success: function() {
            console.log('Shipping Protection added to cart');
            checkShippingProtectionInCart();
            updateCartDisplay();
          },
          error: function(error) {
            console.error('Error adding shipping protection:', error);
            shippingProtectionToggle.prop('checked', false); // Revert toggle on error
          }
        });
      } else {
        // Remove shipping protection from cart
        $.getJSON('/cart.js', function(cart) {
          // Find all instances of the shipping protection product
          const itemsToRemove = cart.items.filter(item => item.product_id === productId && item.variant_id === variantId);
          
          if (itemsToRemove.length > 0) {
            const updates = {};
            itemsToRemove.forEach(item => {
              updates[item.key] = 0;
            });

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {
                updates: updates
              },
              dataType: 'json',
              success: function() {
                console.log('Shipping Protection removed from cart');
                checkShippingProtectionInCart();
                updateCartDisplay();
              },
              error: function(error) {
                console.error('Error removing shipping protection:', error);
                shippingProtectionToggle.prop('checked', true); // Revert toggle on error
              }
            });
          }
        });
      }
    });
});
